import React, { useContext } from "react";

import {
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/system";

import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";

import { SettingsContext } from "../settings-context";

const SettingsMonitoringTable = () => {
  const theme = useTheme();
  const border = `1px solid ${theme.palette.grey[300]}`;
  const tableCellFirst = {
    borderRight: border,
    whiteSpace: "nowrap",
    width: "1px",
  };
  const {
    monitoringCompanyOptions,
    monitoringCompany,
    setMonitoringCompany,
    monitoringSeatsTotal,
    setMonitoringSeatsTotal,
    monitoringSeatsUsed: monitoringSeatsUsed,
  } = useContext(SettingsContext);

  return (
    <TableContainer>
      <Table
        sx={{
          borderTop: border,
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell sx={tableCellFirst}>Enable 24/7 monitoring</TableCell>
            <TableCell>
              <Select
                labelId="monitoring-company-select-label"
                id="monitoring-company-select"
                data-testid="monitoring-company-select"
                onChange={(event: SelectChangeEvent<string>) => {
                  setMonitoringCompany(
                    event.target.value as unknown as MonitoringCompany,
                  );
                }}
                value={String(monitoringCompany)}
                size="small"
              >
                {monitoringCompanyOptions.map((option, key) => (
                  <MenuItem value={option.value} key={key}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={tableCellFirst}>Number of 24/7 seats</TableCell>
            <TableCell>
              <Stack direction="column" gap={2}>
                <Grid
                  container
                  gap={1}
                  alignContent="center"
                  alignItems="center"
                >
                  <Grid item xs={1}>
                    <Typography variant="body1">Available:</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      type="number"
                      label="Seats"
                      value={monitoringSeatsTotal}
                      onChange={(e) => {
                        const value = e.target.value;
                        setMonitoringSeatsTotal(
                          value ? Number(value) : undefined,
                        );
                      }}
                      variant="outlined"
                      size="small"
                      style={{ width: "100%" }}
                      inputProps={{
                        "data-testid": "monitoring-seats-total",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  gap={1}
                  alignContent="center"
                  alignItems="center"
                >
                  <Grid item xs={1}>
                    <Typography variant="body1">Used:</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="body1">
                      {monitoringSeatsUsed}
                    </Typography>
                  </Grid>
                </Grid>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SettingsMonitoringTable;
